import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// import Button from '@eig-builder/core-ui/Button'
// import Icon from '@eig-builder/core-ui/Icon'
// import SnackbarContent from '@material-ui/core/SnackbarContent'
// import Typography from '@eig-builder/core-ui/Typography'

import useInterval from '@eig-builder/core-utils/hooks/useInterval'

// import Text from '@eig-builder/module-localization'
import './lang'

const styles = theme => ({
  snackbar: {
    backgroundColor: theme.palette.primary.dark,
    position: 'fixed',
    bottom: theme.spacing(4),
    left: 230 + 56,
    zIndex: 9999
  },
  text: {
    color: theme.palette.white.main,
    marginLeft: theme.spacing(2)
  }
})

const RefreshIntervalContext = React.createContext({})

const RefreshIntervalContextWrapper = ({ children, classes }) => {
  const [delay, setDelay] = useState(null)
  const [callback, setCallback] = useState(null)
  const [numberOfIntervals, setNumberOfIntervals] = useState(0)

  useInterval(() => {
    setNumberOfIntervals(numberOfIntervals - 1)
    callback()
  }, delay)

  const setInterval = (delayTime, func, tries = 5) => {
    setDelay(delayTime)
    setNumberOfIntervals(tries)
    setCallback(() => func)
    if (tries > 0) {
      setTimeout(() => setDelay(null), tries * delayTime + 1000)
    }
  }

  return (
    <RefreshIntervalContext.Provider
      value={{
        setInterval
      }}
    >
      <>
        {/* {delay && (
          <SnackbarContent
            className={classes.snackbar}
            message={
              <div className='d-flex align-items-center'>
                <Icon icon='info' />
                <Typography className={classes.text} style={{ display: 'inline-block' }}>
                  <Text message='modules.crm.core.refreshInterval.info' values={[delay / 1000, numberOfIntervals]} />
                </Typography>
              </div>
            }
            action={
              <Button size='small' variant='text' color='transparent' onClick={() => setDelay(null)}>
                <Text message='modules.crm.core.refreshInterval.disable' />
              </Button>
            }
          />
        )} */}
        {children}
      </>
    </RefreshIntervalContext.Provider>
  )
}

RefreshIntervalContextWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired
}

export { RefreshIntervalContext }
export default withStyles(styles)(RefreshIntervalContextWrapper)
